
import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'PersonalReturns',
})
export default class PersonalReturns extends Vue {}
